var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.702 2.344A7.7 7.7 0 0 0 7.155 0 7.7 7.7 0 0 0 2.92 1.266 8 8 0 0 0 .076 4.544a.79.79 0 0 0 .358 1.044c.38.187.84.021 1.024-.366a6.44 6.44 0 0 1 2.29-2.64 6.2 6.2 0 0 1 3.407-1.02c3.481 0 6.313 2.888 6.313 6.438s-2.832 6.438-6.313 6.438a6.23 6.23 0 0 1-3.408-1.016 6.4 6.4 0 0 1-2.29-2.64.76.76 0 0 0-1.023-.366.79.79 0 0 0-.358 1.043 7.94 7.94 0 0 0 2.844 3.279A7.73 7.73 0 0 0 7.155 16a7.7 7.7 0 0 0 5.547-2.344A8.02 8.02 0 0 0 15 8a8.02 8.02 0 0 0-2.298-5.656",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.16 8.848H7.928v3.312H6.232V8.848H3V7.312h3.232V4h1.696v3.312h3.232z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdd);
export default __webpack_public_path__ + "static/media/ic_add.33acaf3bc83ba79f167bf9b9628dc716.svg";
export { ForwardRef as ReactComponent };